<template>
  <div class="upload-progress">
    <div class="progress">
      <div
        class="progress-bar"
        role="progressbar"
        :style="progressBarStyle"
        :aria-valuenow="progressValue"
        aria-valuemin="0"
        aria-valuemax="100"
      >
        {{ progressValue }}%
      </div>
    </div>
    <small class="text-muted status-label">
      {{ message }}
    </small>
  </div>
</template>
<script setup lang="ts">
import {computed, type PropType} from "vue";

const props = defineProps({
  progress: {default: 0, type: Number},
  message: {default: null, type: String as PropType<string | null>}
})

const progressValue = computed(() => props.progress.toFixed(2))
const progressBarStyle = computed(() => {
  return {
    width: `${props.progress}%`,
    minWidth: "3rem"
  }
})
</script>
